import { format } from 'date-fns';
import React, { useEffect, useState, useRef } from 'react';
// import styles from '../css/DatePicker.css';

const DatePicker = ({ occasionBooking, selectedDay, selectedMonth, selectedYear, openingTimes, openingHours, mainSchedule, schedule,/*earliestStartDate, latestEndDate, breakStartDateTime, breakEndDateTime,*/ onChange }) => {
    const wrapper = useRef(null);
    const [dateInfo, setDateInfo] = useState({});
    const [showDropdown, setShowDropdown] = useState(false);

    useEffect(() => {
        var dateInfo = {
            menuMonth: selectedMonth,
            menuYear: selectedYear
        }
        setDateInfo(dateInfo);
    }, []);

    const handleClickOutside = (e) => {
        if (wrapper && !wrapper.current?.contains(e.target)) {
            setShowDropdown(false);
            document.removeEventListener('mousedown', handleClickOutside);
        }
    }


    const handleClick = () => {
        setShowDropdown(true);
        document.addEventListener('mousedown', handleClickOutside);
    }

    const handleNextMonthClick = () => {
        let month = dateInfo.menuMonth + 1;
        let year = dateInfo.menuYear;

        if (month == 12) {
            month = 0;
            year++;
        }
        setDateInfo({ ...dateInfo, menuMonth: month, menuYear: year });
    }

    const handlePreviousMonthClick = () => {
        let month = dateInfo.menuMonth - 1;
        let year = dateInfo.menuYear;

        if (month == -1) {
            month = 11;
            year--;
        }


        setDateInfo({ ...dateInfo, menuMonth: month, menuYear: year });
    }

    const handleDateOptionClick = (dateOption) => {
        if (dateOption.selectable) {
            onChange(dateOption.date.getDate(), dateOption.date.getMonth(), dateOption.date.getFullYear());
            setShowDropdown(false);
        }
    }

    const getDays = () => {
        return ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    }

    const dateIsAvailable = (date) => {
        // if (!earliestStartDate || !latestEndDate) {
        //     return true;
        // }
        // if (date >= earliestStartDate && date <= latestEndDate) {
        //     if (!breakStartDateTime || !breakEndDateTime || date < breakStartDateTime || date > breakEndDateTime)
        //         return true;
        // }
        // if (date.getDay() == 1)

        var isAvailable = Object.values(openingTimes[date.getDay()])[0].IsOpen;

        // Check special opening hours (holidays, etc.) for closures
        if (openingHours && openingHours.length > 0) {
            const dateStr = format(date, 'yyyy-MM-dd');
            for (const openingHour of openingHours) {
                if (openingHour.specialOpeningHours && openingHour.days) {
                    for (const day of openingHour.days) {
                        // Check if this special day matches the date and is marked as closed
                        const dayDate = day.startTime ? new Date(day.startTime) : null;
                        if (dayDate && format(dayDate, 'yyyy-MM-dd') === dateStr && day.closed) {
                            isAvailable = false;
                            break;
                        }
                    }
                }
                if (!isAvailable) break;
            }
        }

        if(schedule) {
            var dateKey = format(date, "yyyy-MM-dd");
            isAvailable = isAvailable && !!schedule[dateKey];
        }

        return isAvailable;
    }

    const initializeDateOption = (date) => {
        let today = new Date();
        let now = new Date(Date.now());
        let month = dateInfo.menuMonth;
        let year = dateInfo.menuYear;
        const targetDate = new Date(2026, 2, 5); // March 11, 2026 (month is 0-indexed)

        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);
        targetDate.setHours(0, 0, 0, 0);

        let dateOption = { date: date };
        if (occasionBooking.occasionBookingsFrom && occasionBooking.occasionBookingsTo) {
            var occasionStartDate = new Date(occasionBooking.occasionBookingsFrom.year, occasionBooking.occasionBookingsFrom.month - 1, occasionBooking.occasionBookingsFrom.day)
            var occasionEndDate = new Date(occasionBooking.occasionBookingsTo.year, occasionBooking.occasionBookingsTo.month - 1, occasionBooking.occasionBookingsTo.day)
            if ((occasionStartDate > date || occasionEndDate < date)) {
                dateOption.disabled = true;
            } else {
                dateOption.selectable = true;
            }
            if (date != null && date.getDate() === parseInt(selectedDay) && date.getMonth() === selectedMonth && date.getFullYear() === selectedYear) {
                dateOption.selected = true;
            }
            
            if (!dateIsAvailable(date)) {
                dateOption.disabled = true;
                dateOption.selectable = false;
            }

            dateOption.className = (dateOption.disabled ? "date-picker-date-disabled " : " ") +
                (dateOption.previousMonth ? "date-picker-date-previous-month " : " ") +
                ((dateOption.today && !dateOption.selected) ? "date-picker-date-today " : " ") +
                (dateOption.selectable ? "date-picker-date-selectable " : " ") +
                (dateOption.selected ? "date-picker-date-selected " : " ");

            return dateOption;
        } else {
            // Disable dates before March 11, 2026 or before today (whichever is later)
            const minSelectableDate = today < targetDate ? targetDate : today;

            if (date < minSelectableDate || !dateIsAvailable(date))
                dateOption.disabled = true;
            else
                dateOption.selectable = true;

            if (date.getMonth() < month || date.getYear() < month) {
                dateOption.previousMonth = true;
            }

            if (date.getTime() === today.getTime())
                dateOption.today = true;


            if (date != null && date.getDate() === selectedDay && date.getMonth() === selectedMonth && date.getFullYear() === selectedYear) {
                dateOption.selected = true;
            }

            dateOption.className = (dateOption.disabled ? "date-picker-date-disabled " : " ") +
                (dateOption.previousMonth ? "date-picker-date-previous-month " : " ") +
                ((dateOption.today && !dateOption.selected) ? "date-picker-date-today " : " ") +
                (dateOption.selectable ? "date-picker-date-selectable " : " ") +
                (dateOption.selected ? "date-picker-date-selected " : " ");

            return dateOption;
        }
    }

    const getDateOptions = () => {
        let date = new Date(dateInfo.menuYear, dateInfo.menuMonth, 1);
        let month = dateInfo.menuMonth;
        let year = dateInfo.menuYear;

        let dateOptions = [];

        if (date.getDay() != 1) {
            var shiftedDays = date.getDay() == 0 ? 6 : date.getDay() - 1;
            var earlyDate = new Date(date.getTime());

            for (let i = 1; i <= shiftedDays; i++) {
                earlyDate.setDate(earlyDate.getDate() - 1);
                dateOptions.unshift(initializeDateOption(new Date(earlyDate.getTime())));
            }
        }

        while ((date.getMonth() < month && date.getFullYear() == year) || (date.getMonth() == month && date.getFullYear() == year) || date.getFullYear() < year) {
            dateOptions.push(initializeDateOption(new Date(date.getTime())));

            date.setDate(date.getDate() + 1);
        }


        return dateOptions;
    }

    const getMonthName = (month) => {
        return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][month];
    }

    const formatDateForDisplay = () => {
        if (selectedDay != null) {
            return selectedDay.toString().padStart(2, "0") + "/" + (selectedMonth + 1).toString().padStart(2, "0") + "/" + selectedYear;
        }
    }

    return (
        <>

            <label className="label">Date *</label>
            <div className="date-picker relative">
                <div className="input" onClick={handleClick}>
                    <span>{formatDateForDisplay()}</span>
                </div>
                {showDropdown &&
                    <div className="date-picker-dropdown shadow-lg top-[48px] mt-2" style={{ zIndex: 1000 }} ref={wrapper}>
                        <div className="date-picker-year-month-row">
                            <div className="date-picker-previous-month" onClick={handlePreviousMonthClick}>
                                <div className='box-icon'>
                                    <img src="/icons/common/chevron-up-green.svg" alt="chevron" />
                                </div>
                            </div>
                            <div className="date-picker-current-month">
                                {getMonthName(dateInfo.menuMonth) + " "}
                                {dateInfo.menuYear}
                            </div>
                            <div className="date-picker-next-month" onClick={handleNextMonthClick}>
                                <div className='box-icon'>
                                    <img src="/icons/common/chevron-up-green.svg" alt="chevron" />
                                </div>
                            </div>
                        </div>
                        <div className="date-picker-days">
                            {getDays().map(d => {
                                return (
                                    <div key={"dayName" + d} className="date-picker-day">
                                        {d}
                                    </div>
                                )
                            })}
                            {getDateOptions().map(d => {
                                return (
                                    <div key={"date" + d.date} className={"date-picker-date " + d.className} onClick={() => handleDateOptionClick(d)}>
                                        <div className='day-roundal'>{d.date.getDate()}</div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                }
            </div>
        </>);

}

export default DatePicker;